import { useFlag } from '@unleash/proxy-client-react'
import type { FeatureFlagKey } from '../lib/types'

export const useIsFeatureEnabled = (flagKey: FeatureFlagKey): boolean => {
  return useFlag(flagKey)
}
